// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__cnRlQ","dragIcon":"Choice_dragIcon__H8ssu","left":"Choice_left__76Wx5","input":"Choice_input__2f6by"};